import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { IEpGridModel, IEpGridSelectionOptions, IEpComponentEventArg } from '@epicor/kinetic';
import { BistrackConfig } from 'ep-bt-controls';
import { FieldAgentClient, WorksOrderUserRequest, PagingParameters } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaDocumentDetailService } from '../../services/epbt-fa-document-detail.service';
declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-document-processes-grid',
  templateUrl: './epbt-fa-document-processes-grid.component.html',
  styleUrls: ['./epbt-fa-document-processes-grid.component.scss']
})
export class EpbtFaDocumentProcessesGridComponent implements OnInit {
  webTrackUser: any;
  bistrackSettings: any;
  currency: string;
  gridModel: IEpGridModel;
  pageSize = 10;
  public selectedSupplierItems: any;

  @ViewChild('currencyTemplate', { static: true }) currencyTemplate: TemplateRef<any>;
  @ViewChild('timeTemplate', { static: false }) timeTemplate: TemplateRef<any>;

  constructor(private client: FieldAgentClient, private faService: EpbtFieldAgentService, private config: BistrackConfig, private faDocumentDetailService: EpbtFaDocumentDetailService) { }


  ngOnInit() {
    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.currency = bistrackSettings.baseCurrency.symbol;
    });
    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.gridModel = this.getGridModel();
      this.getGridData();
    });
  }


  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'worksOrderId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: false,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      columns: [
        { field: 'avoName', title: 'Operations', width: 30, hidden: false },
        { field: 'avoOption', title: 'Option', width: 30, hidden: false },
        { field: 'totalCostPrice', title: 'Cost', width: 30, hidden: false, cellTemplate: this.currencyTemplate },
        { field: 'productionTime', title: 'Time', width: 30, hidden: false, cellTemplate: this.timeTemplate },
        { field: 'lineNumber', title: 'Line #', width: 30, hidden: false },
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {

        }
      },
    };
    return model;
  }

  getHeight(): number {
    const height = $(window).outerHeight() - 460;
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }

    return height;
  }

  getGridData() {
    const worksOrderUserRequest = new WorksOrderUserRequest();
    worksOrderUserRequest.user = this.webTrackUser;
    worksOrderUserRequest.worksOrderID = this.faDocumentDetailService.selectedWorkOrderItem.worksOrderId;
    // let parameters = new PagingParameters();
    // parameters.index = 0;
    // parameters.count = 50;
    // worksOrderUserRequest.parameters = parameters;
    this.client.getWorksOrderProcessLines(worksOrderUserRequest).subscribe(res => {
      if (res != null) {
        this.gridModel.data = res;
      }
    });
  }


  onCardClick(model) {

  }



}
